export default "__VITE_ASSET__B$Mlqz9o__"